// extracted by mini-css-extract-plugin
export default {"commentInput":"index_commentInput__tN2NB"};